$(document).ready(function(){
  let selectedTags = {
  kategorie: null,
  thema: null,
  medium: null
};

$(".tag-item").click(function () {
  var $tag = $(this);
  var tagType = '';

  if ($tag.hasClass('kategorie_n')) tagType = 'kategorie';
  else if ($tag.hasClass('thema')) tagType = 'thema';
  else if ($tag.hasClass('medium')) tagType = 'medium';
  else return; 

  var clickedTag = $tag.data("tag");

  if (selectedTags[tagType] === clickedTag) {
    selectedTags[tagType] = null;
    $tag.removeClass('active');
  } else {
    selectedTags[tagType] = clickedTag;
    $(`.tag-item.${tagType}`).removeClass('active');
    $tag.addClass('active');
  }

  let activeTags = [];
  for (let key in selectedTags) {
    if (selectedTags[key]) activeTags.push(selectedTags[key]);
  }

   if (activeTags.length > 0) {
      let displayText = [];
      $(".tag-item.active").each(function() {
        displayText.push($(this).text().trim());
      });
      $(".selected-tags").html(displayText.join(', '));
    } else {
      $(".selected-tags").html('');
    }
  
   if (activeTags.length === 0) {
    $.ajax({
      url: '/blogs/wissensdatenbank', 
      type: 'GET',
      success: function(response) {
        $(".pagination").show();
        var newPosts = $(response).find(".blog-posts1").html();
        $(".blog-articles-tag .blog-posts").html(newPosts);
      },
      error: function() {
        console.error("Error loading default blog posts");
      }
    });
    return;
  }

  let tagFilter = activeTags.join('+');
  let requestUrl = `/blogs/wissensdatenbank/tagged/${tagFilter}`;



  $.ajax({
    url: requestUrl,
    type: 'GET',
    beforeSend: function () {
    },
    success: function (response) {
      $(".pagination").hide();
      var newPosts = $(response).find(".blog-posts1").html();
      $(".blog-articles-tag .blog-posts").html(newPosts);

      $('.myBtn').click(function (e) {
        e.preventDefault();
        const $modal = $(this).parent().find('.modal-box');
        $modal.show();
      });

      $('.close').click(function (e) {
        $('.youtube-video').each(function () {
          this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        });
        $('.modal-box').hide();
      });
    },
    error: function (xhr, status, error) {
      console.error("Error loading tag posts:", error);
    }
  });
});

  
  
});